import { format, formatDistance, isDate } from 'date-fns/esm'
import Cookies from 'js-cookie'

const CONSTANTS = {
  NULL_STR: '--',
  GTS_URL_DATE_FORMAT: 'yyyyMMdd',
  GTS_URL_DATETIME_FORMAT: 'yyyyMMddHHmmss',
  REGEX_ONLY_NUMERIC: /^[0-9]+$/,
}

const utils = {
  DATAGRID_CUSTOM_PADDING_OFFSET: 30,
  MIN_DATAGRID_HEIGHT: 300,
  DATAGRID_SUMMARY_FORMAT: '{0} records',
  GTS_SHORT_DATE_FORMAT: 'd MMM yyyy',
  GTS_DATETIME_FORMAT_FILENAME: 'd_MMM_yyyy__HH_mm_ss',
  GTS_DATETIME_FORMAT_FILENAME_SORTABLE: 'yyyy_MM_d__HH_mm_ss',
  NULL_STR: CONSTANTS.NULL_STR,
  NULL_DATETIME_STR: '1900-01-01T00:00:00',
  NULL_DATETIME_STR_2: '1800-01-01T00:00:00',
  NULLABLE_DATETIME_STR: '0001-01-01T00:00:00',
  NULL_DATETIME_PART: 'T00:00:00',
  MIDDLE_DOT_ASCII: '&#183;',
  DEFAULT_MIME_TYPE: 'application/octet-stream',
  EXCEL_MIME_TYPE:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PDF_MIME_TYPE: 'application/pdf',
  EXPORT_ALL_HOVER_TEXT: { exportAll: 'Export to Excel' },
  ZIP_MIME_TYPE: 'application/zip',
  JPEG_MIME_TYPE: 'image/jpeg',
  PNG_MIME_TYPE: 'image/png',
  DOC_TYPES: {
    PDF: 'pdf',
    ZIP: 'zip',
    DOCX: 'docx',
    XLSX: 'xlsx',
    XLS: 'xls',
  },
  PARTICIPANT_STATUSES: {
    PENDING: { id: 1, name: 'Pending' },
    ENABLED: { id: 2, name: 'Active' },
    DISABLED: { id: 3, name: 'Inactive' },
  },
  ADVISORY_MESSAGE_TYPES: {
    INFO: { display: 'Information', value: 1 },
    WARNING: { display: 'Warning', value: 2 },
    ERROR: { display: 'Error', value: 3 },
  },
  ICON_UNAVAILABLE: `<i class="tiny grey minus icon"></i>`,
  ICON_LOADING: `<i class="spinner loading icon"></i>`,
  FORM_SAVED_TIMEOUT: 2000,
  GET_PAGE_CONFIG_URL: `${API_URL}/components`,
  getCookieId() {
    let _textBase64CombinedCipher = btoa(
      __APPLICATION_ID + __API_VERSION + __ENV,
    )

    // From API
    _textBase64CombinedCipher = _textBase64CombinedCipher.split('=')[0] // Remove any trailing '='s
    // _textBase64CombinedCipher = _textBase64CombinedCipher.replaceAll('+', '-') // 62nd char of encoding
    // _textBase64CombinedCipher = _textBase64CombinedCipher.replaceAll('/', '_') // 63rd char of encoding
    _textBase64CombinedCipher = _textBase64CombinedCipher.replace(/\+/g, '-') // 62nd char of encoding
    _textBase64CombinedCipher = _textBase64CombinedCipher.replace(/\//g, '_') // 63rd char of encoding

    return _textBase64CombinedCipher
  },
  getXSRFTokenFromCookie() {
    const cookieId = this.getCookieId()
    const XSRFCookieName = `XSRF-TOKEN_${cookieId}`

    return Cookies.get(XSRFCookieName)
  },
  setXSRFRequestHeader(jqXHR) {
    let xsrfToken = this.getXSRFTokenFromCookie()
    if (xsrfToken) jqXHR.setRequestHeader('X-XSRF-TOKEN', xsrfToken)
  },
  getParticipantNumberFromInput(fieldValue) {
    if (!fieldValue) return fieldValue

    // Check if number is numeric, if so parse and make string again
    let _participantNumber = isNaN(fieldValue)
      ? fieldValue
      : this.parseInt(fieldValue).toString()

    return _participantNumber
  },
  parsePercentages: (num) => {
    if (!num) return null
    let _number = parseFloat(num)

    if (isNaN(_number)) return null

    if (_number >= 0 && _number < 1) _number = _number * 100

    let pct = Number.isInteger(_number) ? _number : _number.toFixed(3)

    return pct + '%'
  },
  parseInt(num) {
    return parseInt(num, 10)
  },
  parseDateTime: (datetime) => {
    if (!datetime) return

    let d = new Date(datetime)

    var m_names = new Array(
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    )

    let curr_date = d.getDate()
    let curr_month = d.getMonth()
    let curr_year = d.getFullYear()

    return curr_date + ' ' + m_names[curr_month].toUpperCase() + ' ' + curr_year
  },
  formatSummaryOnCellPrepared: function (e) {
    if (e.rowType == 'totalFooter') {
      var summaryItem = $(e.cellElement).find('.dx-datagrid-summary-item')
      if (summaryItem.length > 0) {
        e.cellElement.colSpan = '2'
        summaryItem.html(
          '<i class="blue info circle icon"></i> ' + summaryItem[0].innerHTML,
        )
      }
    }
  },
  customExporter: function (cols, rows) {
    // Remove the last row - which is the totalFooter - where the summary is
    // 99.9% this is the last row so we use .pop method
    rows.pop()
  },
  timeSince(strDate, stringIfNullOrEmpty) {
    if (strDate === null) return stringIfNullOrEmpty || this.ICON_UNAVAILABLE
    return formatDistance(new Date(strDate), new Date(), {
      addSuffix: true,
    })
  },
  formatDate: function (
    datetime,
    strFormat,
    includeTime = false,
    includeSecs = false,
  ) {
    // first check if strDate is valid date
    if (this.isDateNull(datetime)) return null

    let _datetime = datetime

    if (typeof datetime === 'string') {
      _datetime = datetime.match(/^\d{4}-\d{2}-\d{2}$/)
        ? new Date(
            datetime.split('-')[0],
            datetime.split('-')[1] - 1,
            datetime.split('-')[2],
          )
        : new Date(datetime)
    }

    let _formattedDate = format(
      _datetime,
      strFormat ||
        (includeTime
          ? `d MMM yyyy h:mm${includeSecs ? ':ss' : ''} a`
          : this.GTS_SHORT_DATE_FORMAT),
    ).toUpperCase()

    return _formattedDate
  },
  formatDateOrDash(datetime, strFormat, includeTime = false) {
    return this.isDateNull(datetime)
      ? this.ICON_UNAVAILABLE
      : this.formatDate(datetime, strFormat, includeTime)
  },
  isDateNull(datetime) {
    if (!datetime) return true

    let isDateNull =
      typeof datetime === 'string'
        ? datetime === this.NULL_DATETIME_STR ||
          datetime === this.NULL_DATETIME_STR_2
        : datetime.getTime() === new Date(this.NULL_DATETIME_STR).getTime() ||
          datetime.getTime() === new Date(this.NULL_DATETIME_STR_2).getTime()

    return isDateNull
  },
  formatDateURL: function (datetime, dateOnly) {
    if (!datetime) return null
    if (!isDate(datetime)) datetime = new Date(datetime)

    return datetime
      ? format(
          datetime,
          dateOnly
            ? CONSTANTS.GTS_URL_DATE_FORMAT
            : CONSTANTS.GTS_URL_DATETIME_FORMAT,
        )
      : null
  },
  unformatDateURL: function (date, dateOnly = true) {
    if (!date) return null
    if (isDate(date)) return date

    const yyyy = this.parseInt(date.substring(0, 4))
    const MM = this.parseInt(date.substring(4, 6)) - 1
    const dd = this.parseInt(date.substring(6, 8))

    let hh = 0,
      mm = 0,
      ss = 0

    if (!dateOnly) {
      hh = this.parseInt(date.substring(8, 10))
      mm = this.parseInt(date.substring(10, 12))
      ss = this.parseInt(date.substring(12, 14))
    }

    const dt = new Date(yyyy, MM, dd, hh, mm, ss)

    return dt
  },
  formatNumber: function (number) {
    if (number === null || typeof number === 'undefined') return null
    let _number = parseFloat(number)
    return _number.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  },
  formatShares: function (number) {
    return this.formatNumber(number)
  },
  formatMoney: function (number) {
    if (number === null || typeof number === 'undefined') return null
    let _number = parseFloat(number)
    return _number.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  },
  customizeGridTotalItemsText({ value }) {
    let _value = parseFloat(value)
      .toFixed(0)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    let _text = `${_value} record${value === 0 || value > 1 ? 's' : ''}`
    return _text
  },
  /** configure a specific property with time ago formatting - devextreme grid */
  customizeDTCellWithTimeAgo(cellElement, cellInfo) {
    let formattedValue = this.timeSince(cellInfo.value)
    $(
      `<span title="${cellInfo.displayValue}">${formattedValue}</span>`,
    ).appendTo(cellElement)
  },
  customizeDTFull(cellElement, cellInfo) {
    cellElement.innerHTML = this.formatDateOrDash(cellInfo.value, null, true)
  },
  formatDateForDataGrid(cellElement, cellInfo) {
    let formattedValue = this.formatDateOrDash(cellInfo.value)
    $(cellElement).html(formattedValue)
  },
  customizeNullValues(cellElement, cellInfo) {
    let formattedValue = cellInfo.value || this.ICON_UNAVAILABLE
    $(cellElement).html(formattedValue)
  },
  getNumAsTwoDigits: function (n) {
    return (n < 10 ? '0' : '') + n
  },
  getAvailableGridHeight: function (
    selector,
    addPadding = true,
    customPaddingOffset = this.DATAGRID_CUSTOM_PADDING_OFFSET,
  ) {
    let padding = addPadding ? customPaddingOffset : 0

    // safeguard for fast navigation using back buttons when callbacks are being flushed
    if ($(selector).length === 0) return 0

    let height = $(window).height() - $(selector).offset().top - padding
    let finalHeight =
      height >= this.MIN_DATAGRID_HEIGHT ? height : this.MIN_DATAGRID_HEIGHT

    return finalHeight
  },
  getUnique: function (array) {
    return array.filter((value, index, self) => self.indexOf(value) === index)
  },
  returnFileSize: function (number) {
    if (number < 1024) {
      return number + 'bytes'
    } else if (number > 1024 && number < 1048576) {
      return (number / 1024).toFixed(1) + 'KB'
    } else if (number > 1048576) {
      return (number / 1048576).toFixed(1) + 'MB'
    }
  },
  popupWindow(url, title, w = 1060, h = 600) {
    var left = screen.width / 2 - w / 2
    var top = screen.height / 2 - h / 2
    return window.open(
      url,
      title,
      'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=' +
        w +
        ', height=' +
        h +
        ', top=' +
        top +
        ', left=' +
        left,
    )
  },
  getNofFieldsAsString(array) {
    let visibleFields = array.filter((item) => !item.isHidden)

    return [
      '',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
      'thirteen',
      'fourteen',
      'fifteen',
      'sixteen',
    ][this.parseInt(visibleFields.length - 1)]
  },
  clearServerSideErrors($el) {
    let $field = $(`#${$el.target.name}`)
    if ($field.popup('exists')) {
      $field.popup('destroy').closest('.field')
    }
  },
  camelCaseToRegular(str) {
    return (
      str
        .replace(/([A-Z])/g, ' $1')
        // uppercase the first character
        .replace(/^./, function (_str) {
          return _str.toUpperCase()
        })
    )
  },
  stopPropagation() {
    // Dummy click handler
    return false
  },
  copyToClipboard: (str) => {
    // Borrowed from: hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
    const el = document.createElement('textarea')
    el.value = str
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  },
  downloadZipFile(url, payload, successCallback, errorCallback) {
    this.downloadFileFromJSON(
      url,
      payload,
      this.ZIP_MIME_TYPE,
      successCallback,
      errorCallback,
    )
  },
  downloadExcelFile(url, successCallback, errorCallback) {
    this.downloadFileFromJSON(
      url,
      null,
      this.EXCEL_MIME_TYPE,
      successCallback,
      errorCallback,
    )
  },
  downloadFileFromJSON(url, payload, mimeType, successCallback, errorCallback) {
    window.shouldSuppressOBU = true

    let utils = this
    let _config = {
      url,
    }

    if (payload) {
      Object.assign(_config, {
        method: 'POST',
        contentType: 'application/json',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        data: JSON.stringify(payload),
      })
    } else {
      Object.assign(_config, {
        method: 'GET',
      })
    }

    $.ajax(_config)
      .done(function (json, textStatus, jqXHR) {
        utils.processFileData(json.data, mimeType, json.fileName, true)
        if (successCallback) successCallback(json, textStatus, jqXHR)
      })
      .fail(function (jqXHR, statusText, error) {
        if (errorCallback) errorCallback(jqXHR, statusText, error)
        else alert(jqXHR.responseText)
      })

    setTimeout(() => {
      window.shouldSuppressOBU = false
    }, 0)
  },
  downloadFileRaw(url, mimeType, fileName, successCallback, errorCallback) {
    var xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.responseType = 'arraybuffer'

    xhr.withCredentials = true
    xhr.setRequestHeader('x-api-version', __API_VERSION)
    xhr.setRequestHeader('x-app-id', __APPLICATION_ID)
    this.setXSRFRequestHeader(xhr)

    xhr.onload = function () {
      if (xhr.status != 200) {
        // analyze HTTP status of the response
        if (errorCallback) errorCallback(this)
      } else {
        var arrayBuffer = xhr.response // Note: not xhr.responseText
        if (arrayBuffer) {
          utils.processFileData(arrayBuffer, mimeType, fileName, false)
          if (successCallback) successCallback(this)
        }
      }
    }

    try {
      xhr.send(null)
    } catch {
      if (errorCallback) errorCallback(xhr)
    }
  },
  processFileData(response, mimeType, fileName, isBase64) {
    let _blob = this.convertBinaryToBlob(response, mimeType, fileName, isBase64)
    // console.log('processFileData: ' + fileName)
    // for microsoft IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(_blob, fileName)
    } else {
      let _link = document.createElement('a')
      _link.href = window.URL.createObjectURL(_blob)
      _link.download = fileName
      document.body.appendChild(_link)
      _link.click()
      window.URL.revokeObjectURL(_link.href)
      document.body.removeChild(_link)
    }
  },
  convertBinaryToBlob(response, mimeType, fileName, isBase64) {
    // https://stackoverflow.com/questions/34993292/how-to-save-xlsx-data-to-file-as-a-blob
    var buf = null
    if (isBase64) {
      let _response = atob(response)
      buf = new ArrayBuffer(_response.length)
      var view = new Uint8Array(buf)
      for (var i = 0; i != _response.length; ++i)
        view[i] = _response.charCodeAt(i) & 0xff
    } else {
      buf = new Uint8Array(response)
    }

    // IE does not support File constructor
    var blob = null
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      blob = new Blob([buf], {
        type: mimeType,
      })
      // Manually inserting a property called 'name' to mimic new File() for IE11
      blob.name = fileName
    } else {
      // MIME TYPE BREAKS in Firefox where it uses that instead of filename
      // since it is optional, I am taking it out as of Feb 2021 ONLY for .xls legacy excel files;
      if (fileName.split('.')[1] === 'xls') {
        blob = new File([buf], fileName)
      } else {
        blob = new File([buf], fileName, {
          type: mimeType,
        })
      }
    }

    return blob
  },
  printWindow() {
    window.print()
  },
  getAPIErrorMessageHTML(jqXHR) {
    return jqXHR.responseJSON && jqXHR.responseJSON.message
      ? jqXHR.responseJSON.message +
          (jqXHR.responseJSON.referenceNumber
            ? '&nbsp;&nbsp; | &nbsp;&nbsp;Ref #: ' +
              jqXHR.responseJSON.referenceNumber
            : '')
      : jqXHR.statusText
        ? jqXHR.statusText
        : 'Internal Server Error*' // + '&nbsp;&nbsp; | &nbsp;&nbsp;Code: ' + jqXHR.status
  },
  processValidationFormFieldsErrors(jqXHR) {
    let _result = false

    let fieldsWithErrors = JSON.parse(jqXHR.responseText).fields
    if (fieldsWithErrors) {
      for (const f in fieldsWithErrors) {
        if (Object.hasOwnProperty.call(fieldsWithErrors, f)) {
          $('#' + f).closest('.field')
          $('#' + f)
            .popup({
              html: fieldsWithErrors[f].join(),
              on: 'manual',
              closable: false,
              variation: 'tiny',
            })
            .popup('show')
        }
      }

      _result = true
    }

    return _result
  },
  /**
   * Prevents paste of something that does not validate according to the
   * pattern attribute of that element. If no pattern is set on input element,
   * the behavior is defaulting to preventing non-numeric input to be pasted in
   * a numeric ONLY field
   * @param {ClipboardEvent} $event
   */
  preventPaste($event) {
    // 99% of the time pattern is a btoa (base64 encrypted string)
    let _pattern = $event.target.pattern
      ? window.atob($event.target.pattern)
      : CONSTANTS.REGEX_ONLY_NUMERIC

    // IE 11 $event.clipboardData is undefined
    let textToPaste = ($event.clipboardData || window.clipboardData).getData(
      'Text',
    )
    let rxValidText = new RegExp(_pattern)

    if (!rxValidText.test(textToPaste)) {
      $event.preventDefault()
    }
  },
  isNumberOnKeypress: function ($event) {
    $event = $event ? $event : window.event
    var charCode = $event.which ? $event.which : $event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      $event.preventDefault()
    } else {
      return true
    }
  },
  isAlphaNumericOnKeypress: function ($event) {
    $event = $event ? $event : window.event
    var charCode = $event.which ? $event.which : $event.keyCode
    if (
      (charCode >= 48 && charCode <= 57) ||
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122)
    ) {
      return true
    } else {
      $event.preventDefault()
    }
  },
  scrollGridToTop($refs, gridName) {
    let grid = $refs[gridName] ? $refs[gridName].instance : null
    if (!grid) return

    this.scrollGridTo(grid, 1)
  },
  scrollGridToEnd($refs, gridName) {
    let grid = $refs[gridName] ? $refs[gridName].instance : null
    if (!grid) return

    this.scrollGridTo(grid, 0)
  },
  scrollGridTo(grid, top = 1) {
    let scrollView = grid.getScrollable()
    scrollView.scrollTo(top ? 0 : scrollView.scrollHeight())
  },
  getFileExtensionFromFileName(fileName) {
    if (!fileName) return null
    return fileName.slice(-5).split('.')[1].toLowerCase()
  },
  previewAdvisoryMessageIcons(messageTypeId) {
    let _cssClasses = ''
    switch (messageTypeId) {
      case this.ADVISORY_MESSAGE_TYPES.INFO.value:
        _cssClasses = 'blue exclamation circle'
        break

      case this.ADVISORY_MESSAGE_TYPES.WARNING.value:
        _cssClasses = 'orange exclamation triangle'
        break

      case this.ADVISORY_MESSAGE_TYPES.ERROR.value:
        _cssClasses = 'red exclamation triangle'
        break
    }
    return _cssClasses + ' icon'
  },
  messageTypeAsString(messageTypeId) {
    let _cssClass = ''
    switch (messageTypeId) {
      case this.ADVISORY_MESSAGE_TYPES.INFO.value:
        _cssClass = this.ADVISORY_MESSAGE_TYPES.INFO.display.toLowerCase()
        break

      case this.ADVISORY_MESSAGE_TYPES.WARNING.value:
        _cssClass = this.ADVISORY_MESSAGE_TYPES.WARNING.display.toLowerCase()
        break

      case this.ADVISORY_MESSAGE_TYPES.ERROR.value:
        _cssClass = this.ADVISORY_MESSAGE_TYPES.ERROR.display.toLowerCase()
        break
    }
    return _cssClass
  },
}

export default utils
